/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { AlertDialog } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { IBoard } from '@interface/board';
import { boardDelete } from '@lib/versum';

export interface IBoardDelete {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  callback?: (isFromConfirmCallback?: boolean, result?: any) => void;
  board?: IBoard;
}

export const BoardDelete: FC<IBoardDelete> = ({ open, onOpenChange, callback, board }) => {
  const handleConfirm = () => {
    if (board) {
      boardDelete(board.id).then((result) => {
        if (callback) callback(true, result);

        if (onOpenChange) {
          onOpenChange(false);
        }
      });
    }
  };

  const handleCancel = () => {
    if (callback) callback(false);
  };

  return (
    <AlertDialog
      title="Delete Board"
      description="Are you sure you want to delete this Board?"
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      confirmText="Delete"
      canClose={false}
      warning
    >
      <Styles.Content />
    </AlertDialog>
  );
};
